import NoDataImage from "../../../assets/common/profile-no-data.svg";
import "./profileNoData.scss";

function ProfileNoData(props) {
	return (
		<div className="profile-no-data flex-column" style={{ ...props.styles }}>
			<img className="no-data-img" src={NoDataImage} alt="no-data" />
			<span className="no-data-text">{props.noDataText}</span>
		</div>
	);
}

export default ProfileNoData;
